<div class="cart-order-item-row" [class.cart-order-item-row--readonly]="readOnly()">
  @if (!readOnly() && !isOutOfStock() && isCategoryAvailable()) {
    <pxw-counter
      class="cart-order-item-row__counter"
      [count]="quantity()"
      (countChange)="qtyChange.emit($event)"
      (click)="$event.stopPropagation()"
      size="sm"
      [inverted]="true"
      [min]="1"
      [max]="availableStock() || undefined"
    />
  } @else {
    <span class="cart-order-item-row__qty">{{ readOnly() ? '×' : 'x' }}{{ quantity() }}</span>
  }
  @if (presentationLabel()) {
    <div class="cart-order-item-row__title">
      @if (displaySku() && presentationSku()) {
        <p class="cart-order-item-row__sku">{{ presentationSku() }}</p>
      }
      <span class="cart-order-item-row__label">{{ presentationLabel() }}</span>
    </div>
  }
  <pxw-product-resume-price
    class="cart-order-item-row__total"
    [price]="totalWithoutDiscount()"
    [priceDiscount]="total()"
  />
  @if (!readOnly()) {
    <span class="cart-order-item-row__remove">
      @if (showRemove() && isCategoryAvailable()) {
        <button
          type="button"
          class="cart-order-item-row__remove-button"
          [attr.aria-label]="removeLabel()"
          (click)="onRemove($event)"
        >
          <pxw-icon icon="trash-can" size="sm" />
        </button>
      }
    </span>
  }
</div>
@if (stockWarningLabel()) {
  <pxw-tag class="cart-order-item-row__stock" size="xs" type="warning">
    <pxw-icon icon="alert" />
    {{ stockWarningLabel() }}
  </pxw-tag>
}
@if (!readOnly() && !isOutOfStock() && isCategoryAvailable() && upsellHint(); as hint) {
  <pxw-upsell-hint class="cart-order-item-row__upsell-hint" [hint]="hint" />
}
